import React from 'react';
import Header from '../components/Header.jsx';

const Analysis = () => {
	return (
		<div className="Analysis">
			<Header />
			<div>분석 페이지 입니다</div>
		</div>
	);
};

export default Analysis;
